import { QUERY_DATA_CONSTANT } from '../constants/QueryDataConstants';
import properties from 'properties';
import AppUtil from 'js/utils/AppUtil';
import { APP_URL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import AppHelper from 'js/app/AppHelper';

export const processQueryDataResult = result => {
    if ( typeof(result) === 'object' && Array.isArray(result) ) {
        for ( const resultdata of result ) {
            processQueryDataResult(resultdata);
        }
    } else if ( typeof(result) === 'object' ) {
        for ( const key in result ) {
            if ( key === '$date' ) {
                result[key] = new Date(result[key]);
            } else {
                processQueryDataResult( result[key] );
            }
        }
    } else {
        return result;
    }
}

export const populateQueryData = data => {
    return {
        type: QUERY_DATA_CONSTANT.GET_QUERY_DATA,
        payload: {
            data
        }
    }
}

/* istanbul ignore next */
export const getQueryData = ( querydata, callback ) => {
    return dispatch => {
        const url = properties.isIntegrated ? properties.url + APP_URL_CONSTANTS.EXECUTE_QUERY_DATA + "/" + AppHelper.getParamData('sologinid'): "data/QueryData.json";

        AppUtil.ajax(url, querydata, result => {
            processQueryDataResult(result);

            dispatch( populateQueryData(result) );

            if ( callback ) {
                callback();
            }
        });
    }
}